var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWriteReview = function SvgIconWriteReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.796 7.682-1.06-1.06-6.986 6.985v1.06h1.06zm1.06-1.06 1.061-1.061-1.06-1.06-1.061 1.06zm-7.424 9.545H2.25v-3.182L12.326 2.91a.75.75 0 0 1 1.06 0l2.122 2.121a.75.75 0 0 1 0 1.061z"
  })));
};
export default SvgIconWriteReview;